import { I18nLocale } from '#/i18n/types/I18nLocale';
import { searchGetEventsPath } from '#/modules/search/events/routing/searchGetEventsPath';
import { userDashboardCreateEventPath } from '#/modules/userDashboard/routing/userDashboard.paths';
import { postAListingPath } from '#/routing/routes';

import type { ParticipateDropdownData } from './types/ParticipateDropdownData';

export const participateDropdownDataEs: ParticipateDropdownData = {
  search: {
    title: 'Participa',
    items: [
      {
        type: 'participate',
        title: 'Cómo Participar',
        href: '/es/dias/participa',
      },
      {
        type: 'post-event',
        title: 'Publicar un Evento',
        href: userDashboardCreateEventPath.with({}),
        adminUserHref: postAListingPath.with({}),
      },
      {
        type: 'event',
        title: 'Buscar Eventos',
        href: searchGetEventsPath({ locale: I18nLocale.ES }),
      },
    ],
  },
  resources: {
    title: 'Recursos',
    items: [
      {
        type: 'blog',
        title: 'Blog Idealistas',
        description:
          'Inspiración, consejos y recursos para la participación ciudadana y mucho más.',
        href: '/es/accion?pq=',
      },
      {
        type: 'recipe-for-action',
        title: 'Recetas para la Acción',
        description:
          'Una colección de ideas prácticas para generar cambios positivos alrededor del mundo.',
        href: '/es/recetas-para-accion',
      },
    ],
  },
};
